<script setup lang="ts">
/**
 * Valeur sensible d'inventaire (ID/Mdp Apple, code appareil, PUK).
 *
 * Masquée par défaut (« •••••••• ») avec un bouton bascule pour révéler. Une
 * icône cadenas rappelle que la donnée vit dans un coffre chiffré (cf. cahier
 * des charges onboarding/offboarding). Toggle 100 % local — aucune persistance.
 */
import { ref } from 'vue'
import { EyeIcon, EyeSlashIcon, LockClosedIcon } from '@heroicons/vue/24/outline'

defineProps<{ value: string }>()

const revealed = ref(false)
const VAULT_HINT = 'Donnée sensible — coffre chiffré'
</script>

<template>
  <span class="inline-flex min-w-0 max-w-full flex-wrap items-center gap-1.5">
    <LockClosedIcon
      class="h-4 w-4 shrink-0 text-warning"
      aria-hidden="true"
      :title="VAULT_HINT"
    />
    <span class="sr-only">{{ VAULT_HINT }}.</span>

    <span
      v-if="revealed"
      class="min-w-0 font-mono text-sm break-all text-base-content"
    >{{ value }}</span>
    <span v-else class="font-mono text-sm tracking-widest text-base-content/80" aria-hidden="true">••••••••</span>

    <button
      type="button"
      class="btn btn-ghost btn-circle motion-reduce:transition-none"
      :aria-label="revealed ? 'Masquer la valeur' : 'Révéler la valeur'"
      :aria-pressed="revealed"
      @click="revealed = !revealed"
    >
      <EyeSlashIcon v-if="revealed" class="h-5 w-5" aria-hidden="true" />
      <EyeIcon v-else class="h-5 w-5" aria-hidden="true" />
    </button>
  </span>
</template>
